import { boolean, object, string } from 'yup'

const CONCERN_KEYS = [
  'access', 'inaccurate', 'unlawful', 'marketing',
  'disclosure', 'breach', 'retention', 'transparency', 'all',
]

const DataPrivacyComplaintSchema = object().shape({
  full_name: string()
    .required('Full name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,255}$/,
      'Full name can only contain letters and basic punctuation',
    )
    .min(2, 'Full name must be at least 2 characters')
    .max(255, 'Full name must be at most 255 characters')
    .trim(),
  email: string()
    .required('Email is required')
    .matches(
      /^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/,
      'Email must be a valid email address',
    )
    .max(255)
    .trim(),
  relationship: string().required(
    'Please select your relationship to the organisation',
  ),
  submitting_for: string().required('Please select who you are submitting for'),
  representative_details: string().when('submitting_for', {
    is: 'for_someone_else',
    then: (rule) =>
      rule
        .required('Representative name and contact details are required')
        .trim(),
    otherwise: (rule) => rule.optional(),
  }),
  concern_access: boolean(),
  concern_inaccurate: boolean(),
  concern_unlawful: boolean(),
  concern_marketing: boolean(),
  concern_disclosure: boolean(),
  concern_breach: boolean(),
  concern_retention: boolean(),
  concern_transparency: boolean(),
  concern_all: boolean(),
  description: string()
    .required('Please describe what happened')
    .trim(),
  issue_date: string().required(
    'Please select the date the issue first occurred',
  ),
  dealership: string().required('Please select an option'),
  dealership_details: string().when('dealership', {
    is: 'true',
    then: (rule) =>
      rule.required('Please provide details of the dealership').trim(),
    otherwise: (rule) => rule.optional(),
  }),
  impact: string().required('Please describe how this has affected you').trim(),
  outcome: string()
    .required('Please describe the outcome you are seeking')
    .trim(),
  is_lexus: boolean(),
}).test('at-least-one-concern', 'Please select at least one concern', function (values) {
  if (!CONCERN_KEYS.some((key) => (values as any)[`concern_${key}`])) {
    return this.createError({ path: 'concern_access', message: 'Please select at least one concern' })
  }
  return true
})

export default DataPrivacyComplaintSchema
